import {
    GET_SERVICES_FAIL,
    GET_SERVICES_SUCCESS,
    ADD_SERVICE_SUCCESS,
    ADD_SERVICE_FAIL,
    UPDATE_SERVICE_SUCCESS,
    UPDATE_SERVICE_FAIL,
    DELETE_SERVICE_SUCCESS,
    DELETE_SERVICE_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    services: [],
    error: null,
    loading: true
};

const serviceReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des services
        case GET_SERVICES_SUCCESS:
            return {
                ...state,
                services: action.payload, // tableau d'objets service
                loading: false,
                error: null
            };

        case GET_SERVICES_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'une service
        case ADD_SERVICE_SUCCESS:
            return {
                ...state,
                services: [action.payload, ...state.services], // ajoute au début du tableau
                error: null
            };

        case ADD_SERVICE_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Mise à jour d'une service
        case UPDATE_SERVICE_SUCCESS:
            return {
                ...state,
                services: state.services.map(service =>
                    service.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet service
                        : service
                ),
                error: null
            };

        case UPDATE_SERVICE_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Suppression d'une service
        case DELETE_SERVICE_SUCCESS:
            return {
                ...state,
                services: state.services.filter(
                    service => service.id !== action.payload
                ),
                error: null
            };


        case DELETE_SERVICE_FAIL:
            return {
                ...state,
                error: action.payload
            };

        default:
            return state;
    }
};

export default serviceReducer;
